import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getUsers(queryString) {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/users?" + queryString, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching users data or User might not have ssoCustomerAdminRole"
                    });
                }
            });
    },
    getKeycloakUsers(queryString) {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/usersgroups/usersAPI/import-users?" + queryString, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching users data"
                    });
                }
            });
    },
    saveNewUser(newUser) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/users/manage/new-user", newUser).then(response => {
            return response.data;
        }).catch(error => {
            return error.response.data;
        });
    },
    getUserDetails(userId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/users/" + userId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    getUserProfileDetails() {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/profiles")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    getRolesByUser(userId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/users/" + userId + "/roles")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    saveUser(userDto, userId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/users/" + userId, userDto).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    saveUserProfile(userDto) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/profiles", userDto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    disableUser(userId, deletedReason) {
        axios.defaults.withCredentials = true;
        return axios.delete(constants.BASE_URL + "/users/" + userId + "?deletedReason=" + deletedReason).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    enableUser(userId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/users/" + userId + "/restore").then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    unlockUser(userId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/users/unlock/" + userId).then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    updateRoles(userId, changeType, allUserRoles) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/users/" + userId + "/update-roles/" + changeType, allUserRoles)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    updateKeycloakUsers(queryString) {
        var msgType = "fetchSuccess";
        return axios.post(constants.BASE_URL + "/users/import" + queryString, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while updating users"
                    });
                }
            });
    },
    getNonDeletedGroups() {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/users/non-deleted-groups", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching groups"
                    });
                }
            });
    },
    getWorksPlace(val) {
       return axios
        .get(constants.BASE_URL + "/usersgroups/usersAPI/tenantIdentifier", {
            withCredentials: true,
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log("Error Occured is " + error);
            return null;
        });

    }

}